export default "__VITE_ASSET__BRNJxqjf__"